import "./App.css";
import SystemMaintenancePage from "pages/SystemMaintenancePage";
import { useDispatch } from "react-redux";
import { FC, useEffect } from "react";
import { actions } from "./store/maintenance/maintenanceSlice";

const App: FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getMaintenanceCheck({}));
  });
  return <SystemMaintenancePage />;
};

export default App;
